module.exports = __webpack_public_path__ + "img/822f55c.jpg";